import type { CopyShape } from "@tami/core/intl";

import type { LOADING_INDICATOR_COPY_PT_BR } from "../loading-indicator.copy";

export const LOADING_INDICATOR_COPY_EN_US: CopyShape<
  typeof LOADING_INDICATOR_COPY_PT_BR
> = { loading: "Loading" };
